(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/customer-service/assets/javascripts/init.js') >= 0) return;  svs.modules.push('/modules/customer-service/assets/javascripts/init.js'); 
(function(Backbone, _, svs) {
  'use strict';

  Marionette.Behaviors.behaviorsLookup = function() {
    return svs.app.behaviors;
  };

  svs.customer_service.app.start();
})(Backbone, _, svs);

 })(window);